/*
 * @Author: DWP
 * @Date: 2020-11-26 16:07:15
 * @LastEditors: Dong
 * @LastEditTime: 2022-06-01 15:44:57
 */
import React, { Component } from 'react';

class CustomCell extends Component {
  renderSelected = (props = {}, childrenProps = {}) => {
    const { defaultSelection, tbodyStyle = {}, rowIndex, ...restProps } = childrenProps;
    const { tbodyStyle: propStyle, ...otherProps } = props;
    const { singleBackgroundColor, doubleBackgroundColor, backgroundColor } = tbodyStyle;
    const bgColor = rowIndex % 2 === 0 && singleBackgroundColor
      ? singleBackgroundColor
      : doubleBackgroundColor || backgroundColor || '#fff';

    const tdStyle = { ...restProps.style, ...tbodyStyle, backgroundColor: bgColor };

    return (
      <td
        {...restProps}
        {...otherProps}
        style={tdStyle}
      >
        {props.children}
      </td>
    );
  }

  render() {
    const { title, children, style = {}, tbodyStyle = {}, ...resProps } = this.props;
    const { singleBackgroundColor, doubleBackgroundColor, backgroundColor } = tbodyStyle;
    const { record: { __index } = {} } = resProps || {};
    let bgColor = __index % 2 === 0 ? singleBackgroundColor : doubleBackgroundColor;

    if (!bgColor) {
      bgColor = backgroundColor || '#fff';
    }

    // checkbox
    if (this.props.className.indexOf('sup-table-selection-column') >= 0) {
      const childrenProps = this.props.children && this.props.children.length >= 2 && this.props.children[2].props.children.props;
      return this.renderSelected(this.props, childrenProps);
    }

    const tdStyle = {
      ...style,
      ...tbodyStyle,
      backgroundColor: bgColor,
    };

    return (
      <td
        {...resProps}
        title={title}
        style={tdStyle}
      >
        {children}
      </td>
    );
  }
}

export default CustomCell;
